import React from 'react';
import FinraSieExamHeader from './FinraSieExamHeader';
import FinraSeries7ExamHeader from './FinraSeries7ExamHeader';
import FinraSeries63ExamHeader from './FinraSeries63ExamHeader';
import FinraSeries65ExamHeader from './FinraSeries65ExamHeader';
import FinraSeries66ExamHeader from './FinraSeries66ExamHeader';
import GreExamHeader from './GreExamHeader';

const HEADER_CONTENT_MAP = {
  'finra-sie': FinraSieExamHeader,
  'finra-series-7': FinraSeries7ExamHeader,
  // TODO(finra-series-6)
  'finra-series-63': FinraSeries63ExamHeader,
  'finra-series-65': FinraSeries65ExamHeader,
  'finra-series-66': FinraSeries66ExamHeader,
  gre: GreExamHeader,
};

const HeaderContent = (props) => {
  const { productSlug } = props;
  const ExamHeader = HEADER_CONTENT_MAP[productSlug];

  if (!ExamHeader) {
    return null;
  }

  return <ExamHeader />;
};

export default HeaderContent;
